import { Image } from "primereact/image";
import "primeicons/primeicons.css";
import logo from "../assets/images/MEMC-logo.png";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { MySocialNetworks } from "./Common/MySocialNetworks";

function CustomFooter() {
  const { i18n, t } = useTranslation();
  return (
    <div className="footser-bar">
      <div className="reduce-width">
        <hr style={{ borderTop: "1px solid black", margin: "1rem 0" }} />
        <div className="flex justify-content-between flex-wrap">
          <div className="flex align-items-center justify-content-center">
            <div className="flex justify-content-start flex-wrap">
              <Link to="/" className="flex justify-content-center">
                <Image src={logo} alt="Image" width="80" />
              </Link>
              <div
                className="flex align-items-center justify-content-center"
                style={{
                  maxWidth: "30em",
                  lineHeight: "1.4",
                  color: "black",
                  marginLeft: "1em",
                  textAlign: "justify",
                }}
              >
                World embassies, high commissions, consulates, and visa centers.
              </div>
            </div>
          </div>
          <div
            className="flex align-items-center justify-content-center"
            style={{ color: "black" }}
          >
            <div className="flex flex-column flex align-items-end">
              <div className="flex align-items-center justify-content-center">
                Get daily news
              </div>
              <div className="flex align-items-center justify-content-center mt-2">
                {MySocialNetworks()}
              </div>
            </div>
          </div>
        </div>
        <hr style={{ borderTop: "1px solid black", margin: "1rem 0" }} />
        {/* Reste identique */}
        <div className="flex justify-content-between flex-wrap">
          <div style={{ color: "black" }}>
            © 2025 MyEmbassyMyConsulate. {t("all-rights-reserved")}
          </div>
          <ul className="footer-menu">
            <li>
              <Link to={"/" + i18n.language + "/about"}>{t("about")}</Link>
            </li>
            <li>
              <Link to={"/" + i18n.language + "/privacy-terms"}>
                {t("privacy-and-terms")}
              </Link>
            </li>
            <li>
              <Link to={"/" + i18n.language + "/contact"}>{t("contact")}</Link>
            </li>
          </ul>
        </div>
      </div>
    </div>
  );
}

export default CustomFooter;
